module.exports = __webpack_public_path__ + "www/1670826376000/img/app-08.041abe6.png";